export const SET_BREADCRUMB_ITEMS = 'SET_BREADCRUMB_ITEMS';
export const SET_BUTTON_ACTION = 'SET_BUTTON_ACTION';
export const SET_BREADCRUMB_BUTTON_ACTION = 'SET_BREADCRUMB_BUTTON_ACTION';
